module.exports = __webpack_public_path__ + "static/media/false-tone.ea7cebd0.wav";